import { useCallback, useState } from "react";

export const useLoading = (initialLoading: boolean = true) => {
  const [loading, setLoading] = useState(initialLoading);

  const startLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);
  return { loading, setLoading, startLoading, stopLoading };
};
